<template lang="html">
  <div class="newsform">
    <v-form ref="newsform" autocomplete="off" v-model="valid">
      <v-container>
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="newsForm.shortTitle"
              :rules="shortTitleRules"
              :counter="50"
              label="Rövid cím"
              persistent-hint
              hint="Nem jelenik meg az oldalon"
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
          >
            <v-text-field
              v-model="newsForm.fullTitle"
              :rules="fullTitleRules"
              :counter="200"
              label="Teljes cím"
              persistent-hint
              hint="Ez a cím jelenik meg a listázásban"
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
          >
          <v-textarea
            v-model="newsForm.content"
            label="Hír/esemény leírása"
            filled
            outlined
          ></v-textarea>
          </v-col>

          <v-col
            cols="12"
          >
            <v-text-field
              v-model="newsForm.documentLink"
              label="Link a dokumentumokhoz (opcionális)"
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
          >
            <v-text-field
              v-model="newsForm.socialLink"
              label="Link a Facebook-hoz(opcionális)"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-menu
              ref="datepicker"
              v-model="datepicker"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="newsForm.dateOfEvent"
                  label="Az esemény dátuma (opcionális)"
                  persistent-hint
                  hint="Ha megadásra kerül, a dátum alapján kerül besorolásra a listázásnál"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="newsForm.dateOfEvent" no-title @input="menu1 = false"></v-date-picker>
            </v-menu>

          </v-col>

          <v-col
            cols="12"
          >
          <div class="viewImage" v-if="adminmethod==='update' && newsitem.image">
            <v-img max-width=150 :src="newsitem.image"></v-img>
          </div>
          <v-file-input
            class="mb-5"
             show-size
             label="Az eseményhez tartozó kép (opcionális)"
             hint="Max 200kb"
             persistent-hint
             v-model="newsForm.image"
             :rules="[imageRule,]"
             >
            </v-file-input>
          </v-col>
        </v-row>

        <v-row>
          <v-spacer></v-spacer>
          <v-btn class="primary" v-if="adminmethod==='new'" @click.prevent="createNews">Létrehozom!</v-btn>
          <v-btn class="primary" v-else @click.prevent="updateNews">Módosítom!</v-btn>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: ['adminmethod', 'newsitem'],
  data(){
    return{
      valid : false,
      formerrors: false,
      datepicker: false,
      newsForm: {
        shortTitle: this.adminmethod==='update' ? this.newsitem.short_title : '' ,
        fullTitle: this.adminmethod==='update' ? this.newsitem.full_title : '',
        content: this.adminmethod==='update' ? this.newsitem.content : '',
        documentLink: this.adminmethod==='update' && this.newsitem.document_link ? this.newsitem.document_link : '',
        socialLink: this.adminmethod==='update' && this.newsitem.social_link ? this.newsitem.social_link : '',
        image: null,
        dateOfEvent: this.adminmethod==='update' && this.newsitem.date_of_event ? this.newsitem.date_of_event : null,
      },
      shortTitleRules: [
        v => !!v || 'Short title is required',
        v => v.length <= 50 || 'Short title must be less than 50 characters',
      ],
      fullTitleRules: [
        v => !!v || 'Full title is required',
        v => v.length <= 200 || 'Full title must be less than 200 characters',
      ],
      imageRule: (v)=> {
        if (v!==null && v!=='') {
          return v.size < 200000 || 'Image should be less than 200kb!'
        }else return true;
      },

    }
  },
  methods:{
    createForm(){
      if (this.$refs.newsform.validate()) {
        let formdata = new FormData();
        formdata.append('short_title', this.newsForm.shortTitle)
        formdata.append('full_title', this.newsForm.fullTitle)
        formdata.append('content', this.newsForm.content)
        formdata.append('document_link', this.newsForm.documentLink)
        formdata.append('social_link', this.newsForm.socialLink)

        if (this.newsForm.dateOfEvent) {
          formdata.append('date_of_event', this.newsForm.dateOfEvent)
        }
        if (this.newsForm.image) {
          formdata.append('image', this.newsForm.image)
        }
        return formdata;
      }
      else return null;
    },
    createNews(){
      let myform = this.createForm()
      if (myform) {
        axios.post('/api/update-news/', myform,
          {headers:{
              'Authorization': `Token ${this.token}`,
              'Content-Type': 'multipart/form-data'
            },
          })
        .then(res=>{
          this.$store.dispatch('setNews');
          this.$router.push('/hirek')
        })
        .catch(err=>{
          this.formerrors = true;
        })
      }
    },
    updateNews(){
      let myform = this.createForm()
      if (myform) {
        axios.patch(`/api/update-news/${this.newsitem.id}/`, myform,
          {headers:{
              'Authorization': `Token ${this.token}`,
              'Content-Type': 'multipart/form-data'
            },
          })
        .then(res=>{
          this.$store.dispatch('setNews');
          this.$router.push('/')
        })
        .catch(err=>{
          this.formerrors = true;
        })
      }
    }
  },
  computed: {
    token(){
      return this.$store.getters.token;
    },
  },
}
</script>

<style lang="scss" scoped>
.newsform{
  max-width: 600px;
  margin: 0 auto;
}
</style>
